// Cookie consent for visitors in the UK (PECR), the EEA and Switzerland (GDPR
// and ePrivacy rules): there the Google tags start with consent denied (Consent
// Mode v2 region default in index.html, applied by Google from the visitor's IP)
// and the Meta pixel is revoked until the visitor accepts in the banner.
// Everywhere else (the US ...) the tags behave as before.
import { detectVisitorCountry } from "../i18n/locale.js";

// Keep in step with the region list in index.html.
export const CONSENT_COUNTRIES = [
  "AT", "BE", "BG", "HR", "CY", "CZ", "DK", "EE", "FI", "FR", "DE", "GR", "HU", "IE", "IT", "LV",
  "LT", "LU", "MT", "NL", "PL", "PT", "RO", "SK", "SI", "ES", "SE", "IS", "LI", "NO", "CH", "GB",
];

export const CONSENT_STORAGE_KEY = "offlico.consent.v1";
const listeners = new Set();

export function consentRequired(country = detectVisitorCountry()) {
  return CONSENT_COUNTRIES.includes(String(country || "").toUpperCase());
}

// "granted", "denied" or null (not asked yet).
export function storedConsent() {
  try {
    const saved = JSON.parse(window.localStorage.getItem(CONSENT_STORAGE_KEY) || "null");
    return saved && (saved.choice === "granted" || saved.choice === "denied") ? saved.choice : null;
  } catch {
    return null;
  }
}

export function applyConsent(choice) {
  if (typeof window === "undefined") return;
  const state = choice === "granted" ? "granted" : "denied";
  if (typeof window.gtag === "function") {
    window.gtag("consent", "update", {
      ad_storage: state,
      ad_user_data: state,
      ad_personalization: state,
      analytics_storage: state,
    });
  }
  if (typeof window.fbq === "function") window.fbq("consent", state === "granted" ? "grant" : "revoke");
}

export function saveConsent(choice) {
  const value = choice === "granted" ? "granted" : "denied";
  try {
    window.localStorage.setItem(CONSENT_STORAGE_KEY, JSON.stringify({ choice: value, at: new Date().toISOString() }));
  } catch {
    // Private mode: the choice holds for this page only.
  }
  applyConsent(value);
  for (const listener of listeners) listener(value);
}

// Before the Meta pixel's first event: revoked where consent is needed and not given.
export function metaPixelAllowed() {
  return !consentRequired() || storedConsent() === "granted";
}

export function subscribeConsent(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
